import React from 'react'
import { Button, Checkbox, Text, Title } from 'components'
import { formatBRL } from 'utils/formatNumber'
import { paymentMethods } from '../data'
import styles from '../ProposalWizard.module.scss'

const ReviewScreen = ({
  form,
  property,
  onGoToEdit,
  onSubmit,
  isSubmitting,
  termsAccepted,
  onToggleTerms,
  marketingAccepted,
  onToggleMarketing,
}) => {
  const documentLabel = form.personType === 'pj' ? 'CNPJ' : 'CPF'
  const paymentLabel = paymentMethods.find(
    method => method.value === form.paymentMethod
  )?.label

  return (
    <>
      <header className={styles.header}>
        <Title type="h1" fontSize="xlarge">
          Revise sua proposta
        </Title>
        <Text fontSize="medium" color="lightBlueColor">
          Confira as informações antes de enviar sua proposta ao Vendedor.
        </Text>
      </header>
      <main className={styles.main}>
        <Title type="h2" fontSize="large">
          Imóvel e valores
        </Title>
        <dl className={styles.reviewList}>
          <div>
            <dt>Imóvel</dt>
            <dd>{property?.propertyName || '-'}</dd>
          </div>
          <div>
            <dt>Valor anunciado</dt>
            <dd>
              {property.mainValue ? formatBRL(property.mainValue || 0) : '-'}
            </dd>
          </div>
          <div>
            <dt>Valor total da proposta</dt>
            <dd>{formatBRL(form.proposalValue || 0)}</dd>
          </div>
          <div>
            <dt>Forma de pagamento</dt>
            <dd>{paymentLabel}</dd>
          </div>
          {form.paymentMethod !== 'vista' && (
            <div>
              <dt>Valor da entrada</dt>
              <dd>{formatBRL(form.downPaymentValue || 0)}</dd>
            </div>
          )}
          {form.paymentMethod === 'parcelamento' && (
            <div>
              <dt>Número de parcelas</dt>
              <dd>{form.installmentsCount}x</dd>
            </div>
          )}
          <div>
            <dt>Canal de venda</dt>
            <dd>
              {form.hasPartner === 'sim'
                ? form.partnerCode
                : 'Sem canal de venda'}
            </dd>
          </div>
        </dl>

        <Title type="h2" fontSize="large">
          Proponente
        </Title>
        <dl className={styles.reviewList}>
          <div>
            <dt>Nome</dt>
            <dd>{form.name}</dd>
          </div>
          <div>
            <dt>{documentLabel}</dt>
            <dd>{form.document}</dd>
          </div>
          {form.personType !== 'pj' && (
            <div>
              <dt>Data de nascimento</dt>
              <dd>{form.birthDate}</dd>
            </div>
          )}
          <div>
            <dt>E-mail</dt>
            <dd>{form.email}</dd>
          </div>
          <div>
            <dt>WhatsApp</dt>
            <dd>{form.whatsapp}</dd>
          </div>
          {form.personType === 'pj' && (
            <>
              <div>
                <dt>Nome do representante</dt>
                <dd>{form.representativeName}</dd>
              </div>
              <div>
                <dt>CPF do representante</dt>
                <dd>{form.representativeDocument}</dd>
              </div>
              <div>
                <dt>Data de nascimento do representante</dt>
                <dd>{form.representativeBirthDate}</dd>
              </div>
            </>
          )}
        </dl>

        <Title type="h2" fontSize="large">
          Justificativa
        </Title>
        <p className={styles.reviewParagraph}>{form.justification}</p>

        <Title type="h2" fontSize="large">
          Anexos
        </Title>
        <p className={styles.reviewParagraph}>
          {form.attachments?.length
            ? form.attachments.map(file => file.name).join(', ')
            : 'Nenhum anexo adicionado.'}
        </p>

        <Title type="h2" fontSize="large">
          Observações
        </Title>
        <p className={styles.reviewParagraph}>
          {form.observations || 'Sem observações.'}
        </p>

        <div className={styles.importantBox}>
          <Text fontSize="small" color="lightBlueColor">
            <strong>Importante:</strong> o envio desta proposta não representa
            aceite, reserva ou compromisso de venda do imóvel. Caso sua proposta
            avance na triagem inicial, você será informado sobre a necessidade
            de realizar uma caução para que ela siga para análise do Vendedor.
          </Text>
        </div>

        <div className={styles.termsGroup}>
          <Checkbox
            id="termsAccepted"
            option={
              <>
                Li e estou ciente das condições para envio e análise da proposta
                e aceito os{' '}
                <a
                  href="https://resale.com.br/termos"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.termsLink}
                  onClick={e => e.stopPropagation()}
                >
                  termos de uso
                </a>
                .
              </>
            }
            optionPosition="right"
            checked={termsAccepted}
            onChange={onToggleTerms}
            className={styles.termsCheckbox}
          />

          <Checkbox
            id="marketingAccepted"
            option="Aceito receber ofertas da resale.com.br."
            optionPosition="right"
            checked={marketingAccepted}
            onChange={onToggleMarketing}
            className={styles.termsCheckbox}
          />
        </div>
      </main>
      <footer className={styles.footer}>
        <Button
          type="outline"
          className={styles.outlineButton}
          onClick={onGoToEdit}
          id="voltar_editar"
        >
          Voltar e editar
        </Button>
        <Button
          onClick={onSubmit}
          id="enviar_proposta"
          isLoading={isSubmitting}
          disabled={isSubmitting || !termsAccepted || !marketingAccepted}
        >
          Enviar proposta
        </Button>
      </footer>
    </>
  )
}

export default React.memo(ReviewScreen)
